import {NavLink} from "react-router-dom";
import {Fragment} from "react";

const Index = (props) => {

    return (<footer className="pt-24 border-top">
        <div className="container-xxl">
            <div className="row">
                <div className="col-lg-4 mb-5 mb-lg-0"><img src={props.logo}
                                                            style={{height: "40px"}} />

                    <div className="ms-lg-10">
                        <hr/>
                        <h4 className="h6 mb-2 text-muted">تماس با صرافی</h4><a href={"tel:"+window.config.telegram}
                                                                                className="font-bold h2 mb-0 en mt-0 text-end"
                                                                                dir="ltr"> {window.config.phone} </a><p
                        className="text-xs mt-1">تماس با پشتیبانی از ساعت ۱۲ ظهر الی ۱۰ شب امکان پذیر می
                        باشد</p>
                        <hr/>
                        <h4 className="h6 mb-2 text-muted">پشتیبانی تلگرام</h4><a
                        href={"tg://resolve?domain="+window.config.telegram}
                        className="font-bold h4 mb-0 en mt-0 text-end" dir="ltr"> {window.config.telegram} </a>
                        <hr/>
                    </div>
                </div>
                <div className="col-lg-8 ms-lg-auto">
                    <div className="row">
                        <div className="col-sm-3 col-6 ms-lg-auto mb-4 mb-sm-0"><h4 className="h6 mb-2">بخش
                            کاربری</h4>
                            <ul className="list-unstyled text-sm mb-0">
                                {props.auth === null && <li><NavLink to={window.config.staticAddress + "/auth/register"}
                                              className="d-block py-2 text-muted text-dark-hover">ثبت نام</NavLink>
                                </li>}
                                {props.auth === null && <li><NavLink to={window.config.staticAddress + "/auth/register"}
                                              className="d-block py-2 text-muted text-dark-hover">ورود به حساب</NavLink>
                                </li>}
                                {props.auth !== null && <Fragment>
                                    <li><NavLink to={window.config.staticAddress + "/profile/dashboard"}
                                                 className="d-block py-2 text-muted text-dark-hover">پروفایل من</NavLink>
                                    </li>
                                    <li><NavLink to={window.config.staticAddress + "/profile/transactions"}
                                                 className="d-block py-2 text-muted text-dark-hover">تراکنش های من</NavLink>
                                    </li>
                                    <li><NavLink to={window.config.staticAddress + "/profile/payments"}
                                                 className="d-block py-2 text-muted text-dark-hover">واریزی های من</NavLink>
                                    </li>
                                    <li><NavLink to={window.config.staticAddress + "/profile/sells"}
                                                 className="d-block py-2 text-muted text-dark-hover">برداشت های من</NavLink>
                                    </li>

                                </Fragment>}

                            </ul>
                            <h4 className="h6 mt-6 mb-2">صرافی</h4>
                            <ul className="list-unstyled text-sm mb-0">
                                <li><NavLink className="d-block py-2 text-muted text-dark-hover" to={window.config.staticAddress +"/markets"}>قیمت
                                    ارزها و مارکت ها</NavLink></li>

                            </ul>
                        </div>
                        <div className="col-sm-3 col-3 mb-4 mb-sm-0"><h4 className="h6 mb-2">لینک های مفید</h4>
                            <ul className="list-unstyled text-sm mb-0">


                                <li><NavLink className="d-block py-2 text-muted text-dark-hover" to={window.config.staticAddress +"/AboutUs"}>درباره
                                    ما</NavLink></li>
                                <li><NavLink className="d-block py-2 text-muted text-dark-hover" to={window.config.staticAddress +"/ContactUs"}>تماس با
                                    ما</NavLink></li>
                            </ul>
                        </div>
                        <div className="col-sm-3 col-6 mb-4 mb-sm-0"><h4 className="h6 mb-2">ارزها</h4>
                            <ul className="list-unstyled text-sm mb-0">

                                {props.trs && props.trs.map(function (c, i) {

                                    return (
                                        <li key={'sddfdfdsssf'+i} ><NavLink  onClick={()=>{

                                            props.setTraid(c.en)
                                        }}  to={window.config.staticAddress + "/trades/" + c.en + ""} className="d-block py-2 text-muted text-dark-hover">خرید
                                            {' '+ c.name}</NavLink></li>



                                    )
                                })}

                            </ul>
                        </div>

                    </div>
                </div>
            </div>
            <hr className="mt-16 mb-4"/>
            <div className="row align-items-center justify-content-md-between pb-4">
                <div className="col-md-6">
                    <div className="copyright text-sm text-end text-xs-center mb-xs-5">© تمامی حقوق مادی و معنوی
                        برای وب سایت صرافی در نسخه 2.1 محفوظ است.
                    </div>
                </div>
                <div className="col-md-6 text-xs-center" dir="ltr">
                    <ul className="list-inline mb-0">

                        <li className="list-inline-item"><a
                            className="text-lg text-muted text-primary-hover px-1" href={"//t.me/"+window.config.telegram}
                            target="_blank"> <i className="fab fa-telegram"></i> </a></li>

                    </ul>
                </div>
            </div>
        </div>
    </footer>
)
}

export default Index
